"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const ecommerce_1 = require("../../api/ecommerce");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const NativeSelect_1 = __importDefault(require("../../common/js/atoms/NativeSelect"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const array_1 = require("../../common/js/helper/array");
const translation_1 = require("../../common/js/helper/translation");
const Multiselect_1 = __importDefault(require("../atoms/Multiselect"));
const RangeSlider_1 = __importDefault(require("../atoms/RangeSlider"));
const FilterPropertyName_1 = __importDefault(require("../enums/FilterPropertyName"));
const money_1 = require("../helper/money");
const product_1 = require("../helper/product");
const ProductFilter_1 = __importDefault(require("../stores/ProductFilter"));
const ShopwareContext_1 = __importDefault(require("../stores/ShopwareContext"));
const SIMULATE_LOAD_RESET_FILTERS_TIME = 500;
class ProductFilter extends react_1.default.Component {
    showResetFiltersDuringLoadingAnimation = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            showResetFiltersDuringLoadingAnimation: mobx_1.observable,
            availableFilter: mobx_1.computed,
            productPriceRange: mobx_1.computed,
            materialGroupOptions: mobx_1.computed,
            toolOptions: mobx_1.computed,
            currency: mobx_1.computed,
        });
    }
    get availableFilter() {
        const properties = this.props.category.extensions?.massiveCategory?.filterProperties ?? [];
        return properties.slice().sort((a, b) => a.position - b.position);
    }
    get productPriceRange() {
        const from = this.props.products.reduce((lowestPrice, product) => {
            const price = (0, money_1.lowestPriceFromProduct)(product);
            return Math.min(lowestPrice, price);
        }, Infinity);
        const to = this.props.products.reduce((highestPrice, product) => {
            const price = (0, money_1.lowestPriceFromProduct)(product);
            return Math.max(highestPrice, price);
        }, 0);
        return { from, to };
    }
    get materialGroupOptions() {
        return this.props.products
            .map((product) => product.extensions?.massiveMaterials)
            .filter((materials) => (materials?.length ?? 0) > 0)
            .flatMap((material) => material)
            .filter((material) => !!material)
            .map((material) => material.massiveMaterialGroup)
            .filter((materialGroup) => !!materialGroup)
            .reduce((options, materialGroup) => materialGroup.id
            ? [...options, { value: materialGroup.id, label: materialGroup?.translated?.name ?? '' }]
            : options, [])
            .filter((option, index, array) => {
            const otherIndex = array.findIndex((otherOption) => otherOption.value === option.value);
            return index === otherIndex;
        })
            .sort((a, b) => a.label.localeCompare(b.label));
    }
    get toolOptions() {
        return this.props.products
            .map((product) => product.extensions?.massiveTools)
            .filter((tools) => (tools?.length ?? 0) > 0)
            .flatMap((tools) => tools)
            .reduce((toolOptions, tool) => tool.id ? [...toolOptions, { value: tool.id, label: tool.technicalName }] : toolOptions, [])
            .filter((option, index, array) => {
            const otherIndex = array.findIndex((otherOption) => otherOption.value === option.value);
            return index === otherIndex;
        })
            .sort((a, b) => a.label.localeCompare(b.label));
    }
    get currency() {
        return ShopwareContext_1.default.currency?.isoCode ?? null;
    }
    render() {
        return (react_1.default.createElement("div", { className: "znd-product-filter" },
            this.availableFilter.map(this.renderFilterRow),
            Object.values(ProductFilter_1.default.filter).length > 0 || this.showResetFiltersDuringLoadingAnimation ? (react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.secondary, className: "znd-product-filter__btn-clear", text: (0, translation_1.t)('product_filter.clear'), onClick: () => {
                    this.showResetFiltersDuringLoadingAnimation = true;
                    ProductFilter_1.default.reset();
                    setTimeout(() => {
                        this.showResetFiltersDuringLoadingAnimation = false;
                    }, SIMULATE_LOAD_RESET_FILTERS_TIME);
                }, loading: this.showResetFiltersDuringLoadingAnimation })) : null));
    }
    renderFilterRow(filterProperty) {
        if (filterProperty.propertyName === FilterPropertyName_1.default.productPrice && !(0, product_1.showPrices)()) {
            return null;
        }
        switch (filterProperty.propertyName) {
            case FilterPropertyName_1.default.productPrice:
                return react_1.default.createElement(react_1.default.Fragment, { key: filterProperty.propertyName }, this.renderFilterRowPrice());
            case FilterPropertyName_1.default.material:
                return (react_1.default.createElement(react_1.default.Fragment, { key: filterProperty.propertyName }, this.renderFilterRowMaterial()));
            case FilterPropertyName_1.default.tool:
                return react_1.default.createElement(react_1.default.Fragment, { key: filterProperty.propertyName }, this.renderFilterRowTool());
        }
        return filterProperty.propertyId ? (react_1.default.createElement(react_1.default.Fragment, { key: filterProperty.propertyId }, this.renderFilterRowForDynamicFilter(filterProperty))) : null;
    }
    renderFilterRowPrice() {
        const priceRange = this.productPriceRange;
        if (null === this.currency) {
            return null;
        }
        return this.renderGenericRow('price', (0, translation_1.t)('product_filter.price.label'), react_1.default.createElement("div", { className: "form-row align-items-center" },
            react_1.default.createElement("div", { className: "col" },
                react_1.default.createElement("input", { type: "number", className: "form-control", min: Math.floor(priceRange.from), max: Math.ceil(priceRange.to), placeholder: (0, money_1.moneyFormat)(priceRange.from, this.currency), value: ProductFilter_1.default.filter.priceFrom ?? '', onChange: (event) => {
                        const value = event.target.value;
                        const numberValue = Number(value);
                        ProductFilter_1.default.setFilterValue('priceFrom', value === '' || isNaN(numberValue) ? '' : value, this.props.autoApply);
                    } })),
            react_1.default.createElement("div", { className: "col-1 text-center t-body p-0" }, "-"),
            react_1.default.createElement("div", { className: "col" },
                react_1.default.createElement("input", { type: "number", className: "form-control", min: Math.floor(priceRange.from), max: Math.ceil(priceRange.to), placeholder: (0, money_1.moneyFormat)(priceRange.to, this.currency), value: ProductFilter_1.default.filter.priceTo ?? '', onChange: (event) => {
                        const value = event.target.value;
                        const numberValue = Number(value);
                        ProductFilter_1.default.setFilterValue('priceTo', value === '' || isNaN(numberValue) ? '' : value, this.props.autoApply);
                    } }))));
    }
    renderFilterRowMaterial() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.materialGroupOptions.length > 1
                ? this.renderGenericRow('material-group', (0, translation_1.t)('product_filter.material_group.label'), react_1.default.createElement(Multiselect_1.default, { placeholder: (0, translation_1.t)('product_filter.material_group.placeholder'), options: this.materialGroupOptions, value: ProductFilter_1.default.filter.materialGroup?.split(',').filter((item) => !!item) ?? [], onChange: (value) => {
                        ProductFilter_1.default.setFilterValue('materialGroup', value.join(','), this.props.autoApply);
                        ProductFilter_1.default.setFilterValue('material', this.cleanupSelectedMaterials(), this.props.autoApply);
                    } }))
                : null,
            this.getMaterialOptions().length > 1
                ? this.renderGenericRow('material', (0, translation_1.t)('product_filter.material.label'), react_1.default.createElement(Multiselect_1.default, { placeholder: (0, translation_1.t)('product_filter.material.placeholder'), options: this.getMaterialOptions(true), value: ProductFilter_1.default.filter.material?.split(',').filter((item) => !!item) ?? [], onChange: (value) => {
                        ProductFilter_1.default.setFilterValue('material', value.join(','), this.props.autoApply);
                    } }))
                : null));
    }
    renderFilterRowTool() {
        return this.toolOptions.length > 1
            ? this.renderGenericRow('tool', (0, translation_1.t)('product_filter.tool.label'), react_1.default.createElement(Multiselect_1.default, { placeholder: (0, translation_1.t)('product_filter.tool.placeholder'), options: this.toolOptions, value: ProductFilter_1.default.filter.tool?.split(',').filter((item) => !!item) ?? [], onChange: (value) => {
                    ProductFilter_1.default.setFilterValue('tool', value.join(','), this.props.autoApply);
                } }))
            : null;
    }
    renderFilterRowForDynamicFilter(filterProperty) {
        const { filterType, propertyId } = filterProperty;
        if (!propertyId) {
            return null;
        }
        const propertyGroup = (0, array_1.first)((0, product_1.availablePropertyGroups)(this.props.products, [propertyId]));
        if (!propertyGroup || !propertyGroup.id) {
            return null;
        }
        const propertyGroupOptions = (0, product_1.getUniqueSortedPropertyOptions)(this.props.products, propertyGroup.id);
        if (propertyGroupOptions.length <= 1) {
            return null;
        }
        let inputElement = react_1.default.createElement("div", null);
        switch (filterType) {
            case ecommerce_1.MassiveCategoryFilterPropertyFilterTypeEnum.SingleChoice:
                inputElement = this.renderDynamicFilterInputSingleChoice(propertyId, propertyGroupOptions);
                break;
            case ecommerce_1.MassiveCategoryFilterPropertyFilterTypeEnum.MultiChoice:
                inputElement = this.renderDynamicFilterInputMultiChoice(propertyId, propertyGroupOptions);
                break;
            case ecommerce_1.MassiveCategoryFilterPropertyFilterTypeEnum.Range:
                inputElement = this.renderDynamicFilterInputRange(propertyId, propertyGroupOptions);
                break;
        }
        const name = propertyGroup.extensions?.massivePropertyGroup?.translated?.filterName ??
            propertyGroup.translated?.name ??
            '';
        return this.renderGenericRow(propertyId, name, inputElement);
    }
    renderGenericRow(key, label, input) {
        return (react_1.default.createElement("div", { className: `znd-product-filter__row znd-product-filter__row--${key}` },
            react_1.default.createElement("label", { className: "znd-product-filter__label" }, label),
            input));
    }
    renderDynamicFilterInputSingleChoice(propertyId, propertyGroupOptions) {
        const filterValue = `${ProductFilter_1.default.filter[propertyId] ?? ''}`;
        return (react_1.default.createElement(NativeSelect_1.default, { value: filterValue, options: [
                {
                    value: '',
                    label: (0, translation_1.t)('product_filter.dynamic.all'),
                },
                ...propertyGroupOptions,
            ], placeholder: (0, translation_1.t)('product_filter.dynamic.placeholder'), onChange: (value) => {
                ProductFilter_1.default.setFilterValue(propertyId, value, this.props.autoApply);
            } }));
    }
    renderDynamicFilterInputMultiChoice(propertyId, propertyGroupOptions) {
        const filterValue = `${ProductFilter_1.default.filter[propertyId] ?? ''}`;
        const values = filterValue.split(',').filter((item) => !!item);
        return (react_1.default.createElement(Multiselect_1.default, { onChange: (newValues) => {
                ProductFilter_1.default.setFilterValue(propertyId, newValues.join(','), this.props.autoApply);
            }, options: propertyGroupOptions, value: values, placeholder: (0, translation_1.t)('product_filter.dynamic.placeholder') }));
    }
    renderDynamicFilterInputRange(propertyId, propertyGroupOptions) {
        const parsedPropertyGroupOptions = propertyGroupOptions.flatMap((propertyGroupOption) => parseInt(propertyGroupOption.label));
        const unitRegEx = new RegExp('\\s+(?<unitLabel>[^\\s]+)$');
        const unitMatch = (0, array_1.first)(propertyGroupOptions)?.label?.match(unitRegEx);
        const unitLabel = ' ' + (unitMatch?.groups?.unitLabel ?? '');
        const max = Math.max(...parsedPropertyGroupOptions) ?? 0;
        const filterNumber = Number(ProductFilter_1.default.filter[propertyId] ?? 0);
        const value = isNaN(filterNumber) ? 0 : filterNumber;
        return (react_1.default.createElement("div", { className: "row align-items-center flex-nowrap" },
            react_1.default.createElement("div", { className: "col pr-0" },
                react_1.default.createElement(RangeSlider_1.default, { max: max, min: 0, onChange: (newValue) => {
                        ProductFilter_1.default.setFilterValue(propertyId, newValue, this.props.autoApply);
                    }, value: value })),
            react_1.default.createElement("div", { className: "col-4 col-lg-3 col-xl-4 t-body text-right text-nowrap" }, String(value) + unitLabel)));
    }
    getMaterialOptions(reducedBySelectedMaterialGroup = false) {
        return this.props.products
            .map((product) => product.extensions?.massiveMaterials)
            .filter((materials) => (materials?.length ?? 0) > 0)
            .flatMap((material) => material)
            .filter((material) => !!material)
            .filter((material) => {
            if (!reducedBySelectedMaterialGroup) {
                return true;
            }
            const selectedMaterialGroups = ProductFilter_1.default.filter.materialGroup?.split(',').filter((item) => !!item);
            return selectedMaterialGroups?.length
                ? selectedMaterialGroups.indexOf(material.massiveMaterialGroupId) !== -1
                : true;
        })
            .reduce((options, material) => material.id
            ? [...options, { value: material.id, label: material.translated?.name ?? '' }]
            : options, [])
            .filter((option, index, array) => {
            const otherIndex = array.findIndex((otherOption) => otherOption.value === option.value);
            return index === otherIndex;
        })
            .sort((a, b) => a.label.localeCompare(b.label));
    }
    cleanupSelectedMaterials() {
        const selectedMaterials = ProductFilter_1.default.filter.material?.split(',').filter((item) => !!item) ?? [];
        const selectableMaterials = this.getMaterialOptions(true);
        return selectableMaterials
            .map(({ value }) => value)
            .filter((value) => {
            return selectedMaterials.indexOf(value) !== -1;
        })
            .join(',');
    }
}
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "renderFilterRow", null);
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "renderFilterRowPrice", null);
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "renderFilterRowMaterial", null);
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "renderFilterRowTool", null);
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "renderFilterRowForDynamicFilter", null);
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "renderGenericRow", null);
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "renderDynamicFilterInputSingleChoice", null);
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "renderDynamicFilterInputMultiChoice", null);
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "renderDynamicFilterInputRange", null);
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "getMaterialOptions", null);
__decorate([
    bind_decorator_1.default
], ProductFilter.prototype, "cleanupSelectedMaterials", null);
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(ProductFilter));
